<template>
    <div class="banner">
        <div class="context">
            <div class="title">ZADA CASH is your trusted</div>
            <div class="title">financia partner</div>
            <div class="text">Zada Cash provides convenient credit services without high fees, simple application steps and fast approval. Zada ​​Cash is your trusted financial partner.</div>
            <div class="btns">
              <div class="btn_left"></div>
              <div class="btn_right"></div>
            </div>
            <!-- <div class="submit">Fast and Reliable</div> -->
        </div>
        <img src="@/assets/banner_icon.png">
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    created() {
    },
    methods: {

    }
};
</script>

<style lang="scss" scoped>
.banner {
    width: 100%;
    height: 797px;
    position: relative;
    background: url('./../assets/banner.png') 0 0 no-repeat;
    background-size: 100% 100%;
    .context {
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding-left: 181px;
      height: 100%;
      .title {
        font-family: 'Lexend_Regular';
        font-weight: 400;
        font-size: 65px;
        color: #FFFFFF;
        line-height: 81px;
      }
      .text {
        margin-top: 23px;
        width: 606px;
        height: 87px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 19px;
        color: #FFFFFF;
        line-height: 29px;
      }
      .btns {
        display: flex;
        margin-top: 93px;
        .btn_left {
          width: 190px;
          height: 54px;
          background: url('./../assets/googlePlay.png') 0 0 no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
        }
        .btn_right {
          width: 157px;
          height: 54px;
          background: url('./../assets/appStore.png') 0 0 no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
          margin-left: 11px;
        }
      }
      .submit {
        margin-top: 60px;
        width: 258px;
        height: 62px;
        text-align: center;
        line-height: 63px;
        background-color: #ffd32b;
        border-radius: 8px;
        cursor: pointer;
        font-size: 20px;
      }
    }
    img {
      position: absolute;
      width: 543px;
      height: 696px;
      top: 35px;
      right: 95px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue